export default "__VITE_ASSET__abc70cc7__"